/* eslint-disable react/prop-types */
import React from 'react';
import { InputPrefix as OriginalInputPrefix } from '@fiverr-private/forms';
import { useParentPropsOverrideContext } from '@fiverr-private/ui_utils';

const InputPrefix = ({ children, ...props }) => {
    const context = useParentPropsOverrideContext();

    return (
        <OriginalInputPrefix {...props} {...context}>
            {children}
        </OriginalInputPrefix>
    );
};

export default InputPrefix;
